import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {StudyOverviewViewQuery} from 'studies/workspace/overview/__generated/StudyOverviewViewQuery';

import {StudyOverviewContext} from '../shared/MultiProcedureRunOverviewTabContents';
import MultiProcedureRunListingTable from './MultiProcedureRunListingTable';
import ProcedureRunDetailsView from './ProcedureRunDetailsView';

type StudyNode = ExtractByTypename<StudyOverviewViewQuery['study'], 'StudyNode'>;

export default function MultiExperimentProcessDevelopmentOverview({study}: {study: StudyNode}): JSX.Element {
  const {selectedProcedureRun, setSelectedProcedureRun, currentProcedureRunTab} =
    StudyOverviewContext.useContext();
  return (
    <div className={css(styles.studyBackground)}>
      {selectedProcedureRun.id == null ? (
        <MultiProcedureRunListingTable studyId={study.id} setSelectedProcedureRun={setSelectedProcedureRun} />
      ) : (
        <ProcedureRunDetailsView
          studyType={study.studySchema.studyType}
          selectedProcedureRun={selectedProcedureRun}
          currentProcedureRunTab={currentProcedureRunTab}
        />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  studyBackground: {
    backgroundColor: Color.GRAY_100,
  },
});
